import React from "react";
import "./ApplyCC.css";
import { FaMoneyBillWave } from "react-icons/fa";

const ApplyCC = () => {
  return (
  

    <div className="Applyccloancontainer">
      <h2 className="Applyccloancontainer-title">Service Details</h2>
    <p className="Applyccloancontainer-subtitle">Choose loan type to choose service.</p>
      <div className="Applyccloan-form-container">
        
        {/* Row 1 */}
        <div className="Applyccloan-form-row">
          <div className="Applyccloan-service-col">
            <label htmlFor="loanService">Choose Loan Service</label>
            <select id="loanService" className="Applyccloan-service-select">
              <option value="">Select loan service</option>
            </select>
          </div>

          <div className="Applyccloan-min-amount-col highlight-box">
            <label htmlFor="minLoanAmount">
              <FaMoneyBillWave className="Applyccloan-icon" /> Min. Loan Amount
            </label>
            <input
              type="number"
              id="minLoanAmount"
              className="Applyccloan-min-amount-input"
              placeholder="Minimum loan amount"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="Applyccloan-form-row">
          <div className="Applyccloan-roi-col highlight-box">
            <label htmlFor="maxLoanAmount">Max. Loan Amount</label>
            <input
              type="number"
              id="maxLoanAmount"
              className="Applyccloan-roi-frequency-inputs"
              placeholder="Enter max loan amount"
            />
          </div>

          <div className="Applyccloan-roi-col">
            <label htmlFor="loanROI">Choose Loan ROI</label>
            <select id="loanROI" className="Applyccloan-roi-select">
              <option value="">Select loan ROI</option>
            </select>
          </div>
        </div>

        {/* Row 3 */}
        <div className="Applyccloan-form-row">
          <div className="Applyccloan-roi-frequency-col">
            <label htmlFor="loanROIFreq">Choose Loan ROI Frequency</label>
            <input
              type="text"
              id="loanROIFreq"
              className="Applyccloan-roi-frequency-input"
              placeholder="Enter ROI frequency"
            />
          </div>

          <div className="Applyccloan-roi-type-col highlight-box">
            <label htmlFor="loanROIType">Choose Loan ROI Type</label>
            <input
              type="text"
              id="loanROIType"
              className="Applyccloan-roi-type-input"
              placeholder="Enter ROI type"
            />
          </div>
        </div>

        {/* Row 4 */}
        <div className="Applyccloan-form-row">
          <div className="Applyccloan-amount-col">
            <label htmlFor="loanAmount">Loan Amount</label>
            <input
              type="number"
              id="loanAmount"
              className="Applyccloan-amount-input"
              placeholder="Enter loan amount"
            />
          </div>

          <div className="Applyccloan-recovery-col">
            <label htmlFor="loanRecovery">Choose Loan Recovery Frequency</label>
            <select id="loanRecovery" className="Applyccloan-recovery-select">
              <option value="">Select recovery frequency</option>
            </select>
          </div>
        </div>

        {/* Row 5 */}
        <div className="Applyccloan-form-row">
          <div className="Applyccloan-disbursal-col">
            <label htmlFor="loanDisbursal">Choose Loan Disbursal Mode</label>
            <select id="loanDisbursal" className="Applyccloan-disbursal-select">
              <option value="">Select disbursal mode</option>
            </select>
          </div>

          <div className="Applyccloan-applied-date-col">
            <label htmlFor="loanAppliedDate">Loan Applied Date</label>
            <input
              type="date"
              id="loanAppliedDate"
              className="Applyccloan-applied-date-input"
            />
          </div>
        </div>

        {/* Row 6 */}
        <div className="Applyccloan-form-row">
          <div className="Applyccloan-emi-col">
            <label htmlFor="emiAmount">EMI Amount</label>
            <input
              type="number"
              id="emiAmount"
              className="Applyccloan-emi-input"
              placeholder="Enter EMI amount"
            />
          </div>
        </div>
      </div>

            <div className="Applyccloansuser-details-container">
              {/* Search Button */}
  <div className="Applyccloanssearch-box">
    <button className="Applyccloanssearch-btn">Click here to search user</button>
  </div>
  <h2 className="Applyccloansform-title">User Details</h2>

  

  {/* User Info Section */}
  <div className="Applyccloansform-section">
    <div className="Applyccloansform-row">
      <div className="Applyccloansform-col">
        <label>User Id</label>
        <input type="text" placeholder="Enter user id" />
      </div>
      <div className="Applyccloansform-col">
        <label>User Name</label>
        <input type="text" placeholder="User name" />
      </div>
    </div>

    <div className="Applyccloansform-row">
      <div className="Applyccloansform-col">
        <label>Aadhar Number</label>
        <input type="text" placeholder="Aadhar number" />
      </div>
      <div className="Applyccloansform-col">
        <label>Pan Number</label>
        <input type="text" placeholder="Pan number" />
      </div>
    </div>

    <div className="Applyccloansform-row">
      <div className="Applyccloansform-col">
        <label>Guardian Name</label>
        <input type="text" placeholder="Guardian name" />
      </div>
      <div className="Applyccloansform-col">
        <label>Mobile Number</label>
        <input type="text" placeholder="Mobile number" />
      </div>
    </div>

    <div className="Applyccloansform-row">
      <div className="Applyccloansform-col">
        <label>Address</label>
        <input type="text" placeholder="Address" />
      </div>
      <div className="Applyccloansform-col">
        <label>Bank Account</label>
        <input type="text" placeholder="Bank Account" />
      </div>
    </div>

    <div className="Applyccloansform-row">
      <div className="Applyccloansform-col">
        <label>Bank IFSC Code</label>
        <input type="text" placeholder="Bank IFSC Code" />
      </div>
      <div className="Applyccloansform-col">
        <label>User Type / Role</label>
        <input type="text" placeholder="User Type / Role" />
      </div>
    </div>
  </div>
</div>


           
          <div className="Applysccloanguarantor-details-container">
  <h2 className="Applysccloanform-title">Guarantor Details</h2>
  <p className="Applysccloanform-subtitle">Assign new/registered user as guarantor.</p>

  <div className="Applysccloanform-section">
    <div className="Applysccloanform-row">
      <div className="Applysccloanform-col">
        <label>Guarantor User Id (Optional)</label>
        <input type="text" placeholder="Guarantor user id" />
      </div>
      <div className="Applysccloanform-col">
        <label>Guarantor Name</label>
        <input type="text" placeholder="Guarantor name" />
      </div>
    </div>

    <div className="Applysccloanform-row">
      <div className="Applysccloanform-col">
        <label>Choose Guarantor Relation</label>
        <select>
          <option value="">Select guarantor relation</option>
          <option value="father">Father</option>
          <option value="mother">Mother</option>
          <option value="spouse">Spouse</option>
          <option value="brother">Brother</option>
          <option value="sister">Sister</option>
          <option value="friend">Friend</option>
        </select>
      </div>
      <div className="Applysccloanform-col">
        <label>Guarantor DOB</label>
        <input type="date" placeholder="dd-mm-yyyy" />
      </div>
    </div>

    <div className="Applysccloanform-row">
      <div className="Applysccloanform-col">
        <label>Guarantor Aadhar Number</label>
        <input type="text" placeholder="Guarantor aadhar number" />
      </div>
      <div className="Applysccloanform-col">
        <label>Guarantor Pan Number</label>
        <input type="text" placeholder="Guarantor pan" />
      </div>
    </div>
  </div>
</div>


         <button className="Applyccloansubmit-btn">Submit Application</button>


    </div>
  );
};

export default ApplyCC;
